module.exports = __webpack_public_path__ + "static/media/terra-sq.3b4d58fc.jpg";